import { Box, ImageListItem } from "@mui/material";
import React from "react";
import OcrButton from "./ocrButton";

const IssueAttachmentsView = ({ item, issueType }: any) => {
  return (
    <Box sx={{ position: "relative" }}>
      <ImageListItem>
        <img
          src={`${item}?w=140&h=140&fit=crop&auto=format`}
          srcSet={`${item}?w=140&h=140&fit=crop&auto=format&dpr=2 2x`}
          alt="img"
          loading="lazy"
          style={{
            maxHeight: 180,
            borderRadius: 10,
            cursor: "pointer",
          }}
          onClick={() => window.open(item, "_blank")}
        />
      </ImageListItem>
      {issueType === "Payout" ? <OcrButton item={item} /> : null}
    </Box>
  );
};

export default IssueAttachmentsView;
